import { useAuth } from "../lib/auth";
import { useState, useEffect } from "react";
import { api } from "../lib/api";
import { LogOut, RefreshCw } from "lucide-react";

export default function Topbar({ title, subtitle, demo = false, live = false, right = null, onRefresh = null, refreshing = false, lastRefreshed = null }) {
  const { user, logout } = useAuth();
  const [workspaceName, setWorkspaceName] = useState("");

  useEffect(() => {
    if (!user?.workspace_id) return;
    api.get("/workspaces").then((r) => {
      const w = (r.data.workspaces || []).find((x) => x.id === user.workspace_id);
      if (w) setWorkspaceName(w.name);
    }).catch(() => {});
  }, [user]);

  return (
    <div className="topbar px-6 py-3.5 flex items-center gap-4 sticky top-0 z-20" data-testid="topbar">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2.5">
          <h1 className="font-heading font-semibold text-[18px] tracking-tight truncate" data-testid="topbar-title">{title}</h1>
          {live && (
            <span
              className="inline-flex items-center gap-1 text-[10.5px] font-mono uppercase tracking-wide px-1.5 py-[1px] rounded"
              style={{ background: "#dcfce7", color: "#14532d", border: "1px solid #86efac" }}
              data-testid="live-badge"
              title="Reading directly from the Camaroo QA database"
            >
              <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: "#16a34a" }} />
              Live QA Data
            </span>
          )}
          {workspaceName && (
            <span className="pill info" data-testid="topbar-workspace">{workspaceName}</span>
          )}
        </div>
        {subtitle && <div className="text-[12.5px] mt-0.5" style={{ color: "var(--c-text-muted)" }}>{subtitle}</div>}
      </div>
      <div className="flex items-center gap-2">
        {onRefresh && (
          <button className="btn btn-outline" onClick={onRefresh} disabled={refreshing} data-testid="topbar-refresh">
            <RefreshCw size={14} strokeWidth={1.7} className={refreshing ? "animate-spin" : ""} />
            <span>{refreshing ? "Refreshing…" : "Refresh"}</span>
          </button>
        )}
        {lastRefreshed && (
          <span className="text-[11.5px]" style={{ color: "var(--c-text-muted)" }} data-testid="topbar-last-refreshed">
            Last refreshed {new Date(lastRefreshed).toLocaleTimeString()}
          </span>
        )}
        {right}
        <button className="btn btn-ghost" onClick={logout} data-testid="topbar-logout">
          <LogOut size={14} strokeWidth={1.7} /> Logout
        </button>
      </div>
    </div>
  );
}
